import { format, startOfTomorrow } from "date-fns";
import { ar } from "date-fns/locale";
import { LANG_EN } from "../Components/Templates/WeddingTemplates/constants";
import { convertDigitsToArabicNumerals } from "./formatNumbersToArabic";
import { toZonedTime } from "date-fns-tz";

export const formatNumbersToArabic = (
	date: Date | string,
	pattern = "PPp",
	timezone: string = "Africa/Cairo"
): string => {
	const zonedDate = toZonedTime(date, timezone || "Africa/Cairo");

	const formatted = format(zonedDate, pattern, { locale: ar }).replace(/,\s*/g, "، ");

	// Convert digits to Arabic numerals
	return convertDigitsToArabicNumerals(formatted);
};

export const formatDate = (date: Date | string, timezone: string = "Africa/Cairo", pattern = "PPp") => {
	const zonedDate = toZonedTime(date, timezone || "Africa/Cairo");
	return format(zonedDate, pattern);
};

export const getWeddingDate = (
	wedding_date: string,
	language: string,
	timezone: string = "Africa/Cairo",
	isTemplate: boolean = false,
	pattern = "PPp"
) => {
	if (language === LANG_EN) {
		const _wedding_date = wedding_date || new Date();
		return formatDate(isTemplate ? new Date(startOfTomorrow()) : _wedding_date, timezone, pattern);
	}
	return formatNumbersToArabic(
		isTemplate ? new Date(startOfTomorrow()) : wedding_date || new Date(),
		pattern,
		timezone
	);
};
